import posthog from 'posthog-js';
import { useEffect } from 'react';

import { useDialog } from '../hooks/useDialog';
import { useNavigator } from '../hooks/useNavigator';
import { useStore } from '../hooks/useStore';
import useTranslation from '../hooks/useTranslation';

import DeviceTypeSelect from '../components/DeviceTypeSelect';
import StepTemplate from '../components/StepTemplate';
import { Button } from '@/lib/components/ui/button';
import { SpinnerButton } from '@/lib/components/ui/spinnerButton';

const DeviceStep = () => {
  const translations = useTranslation();
  const navigateForward = useNavigator((state) => state.navigateForward);
  const setShowDialog = useDialog((state) => state.setShowDialog);

  const selectedModel = useStore((state) => state.selectedModel);
  const loadingGradingForm = useStore((state) => state.loadingGradingForm);
  const gradingForm = useStore((state) => state.gradingForm);
  const getGradingForm = useStore((state) => state.getGradingForm);

  useEffect(() => {
    posthog.capture('Open Device Select Step');
  }, []);

  useEffect(() => {
    getGradingForm();
  }, [selectedModel]);

  return (
    <StepTemplate
      title={translations.categoryTitle}
      subTitle={translations.categorySubTitle}
      step={1}
      footer={
        <div className="flex space-x-4">
          <Button
            onClick={() => setShowDialog(false)}
            aria-label={translations['close']}
            variant={'outline'}
          >
            {translations['close']}
          </Button>
          <SpinnerButton
            disabled={!selectedModel || !gradingForm}
            onClick={navigateForward}
            loading={loadingGradingForm}
            aria-label={translations['price']}
          >
            {translations['price']}
          </SpinnerButton>
        </div>
      }
    >
      <DeviceTypeSelect />
    </StepTemplate>
  );
};

export default DeviceStep;
